import React from 'react'
import { Search, Settings, CheckCircle } from "lucide-react";

const ServiceIntro = () => {
  const steps = [
    {
      icon: Search,
      title: "Free Discovery Call",
      description: "Understand your tracking goals and challenges"
    },
    {
      icon: Settings,
      title: "Audit or Implementation",
      description: "I fix or build your setup based on your needs"
    },
    {
      icon: CheckCircle,
      title: "Tracking Clarity",
      description: "You receive a fully tested and documented solution"
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center animate-on-scroll">
          <div className="mb-12">
            <h2 className="mb-6">Introducing <span className="text-primary">Tagnetica</span></h2>
            <h3 className="text-2xl text-text-secondary mb-6">Analytics & Tag Management Expertise</h3>
            <p className="text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto">
              Fast, reliable help with Google Tag Manager, GA4, and Matomo. From audits to new implementations, 
              I ensure your tracking is correct, complete, and future-proof.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="relative animate-on-scroll"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="bg-white border-2 border-primary/20 rounded-xl p-6 sm:p-8 text-center hover:shadow-lg transition-all duration-300 hover:border-primary/40">
                  <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                    <step.icon className="h-8 w-8 text-primary" />
                  </div>
                  <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold absolute -top-4 -left-4">
                    {index + 1}
                  </div>
                  <h4 className="text-xl font-semibold text-text-primary mb-4">{step.title}</h4>
                  <p className="text-text-secondary leading-relaxed">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-primary/30 transform -translate-y-1/2"></div>
                )}
              </div>
            ))}
          </div>

          <div className="bg-accent/30 border border-primary/20 rounded-2xl p-6 sm:p-8 animate-on-scroll">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <img src="/tagnetica-badge.webp" alt="Tagnetica logo" className="w-16 h-16 object-contain rounded-full p-2" />
              </div>
              <div className="flex-1 text-left">
                <blockquote className="text-lg text-text-primary italic mb-4">
                  "We are software development and digital analytics specialists who have worked with agencies and brands to untangle 
                  and optimise their tracking setups. We know how frustrating it is to work with messy data 
                  or broken tags. Our mission is to simplify tracking so you can focus on growth."
                </blockquote>
                <cite className="text-primary font-semibold">— Samantha, Founder</cite>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceIntro;
